import React, { useCallback, useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { REACT_COMPONENT_CLASSNAME } from '@lyearn/lygo-core';
import { ClickAwayListener, Popper } from '@lyearn/ui';

import BlockMenuList from '../../components/Menu/BlockMenuItems';
import TurnIntoMenuItems from '../../components/Menu/TurnIntoMenuItems';
import { PopperProps } from '../../types';
import { blockType } from '../../types/menus';
import { getTextOnlyNode } from '../../utils';
import { getSelectedMenuItemIndex, hideBlockMenu, onTurnIntoClick } from './utils/utils';
import { menuItems } from './consts';
import { BlockMenuProps, MenuType } from './types';
import { useCurrentlySelectedNode, usePopperOptions } from './useBlockMenuActions';

export const BLOCK_MENU_POPPER_ID = 'block-menu-popper';

export const BlockMenuComponent: React.FC<BlockMenuProps> = (props) => {
  let { open, anchorEl, view, menuType, isLocalizedContent } = props;
  const { t } = useTranslation();
  const { popperOptions, placement } = usePopperOptions(anchorEl, getTextOnlyNode(view).length);
  const currentlySelectedNode = useCurrentlySelectedNode(open, anchorEl, view);

  const onClickAway = useCallback(() => {
    hideBlockMenu(view);
    const anchorElement = anchorEl as HTMLElement;
    if (anchorElement && anchorElement.classList.contains(REACT_COMPONENT_CLASSNAME)) {
      (anchorEl as HTMLElement).classList.remove('block-menu-selected');
    }
  }, [anchorEl, view]);

  return (
    <ClickAwayListener mouseEvent="onMouseUp" onClickAway={onClickAway}>
      <Popper
        anchorEl={anchorEl}
        className="z-10 rounded-8 border border-divider bg-bg-primary shadow-02"
        id={BLOCK_MENU_POPPER_ID}
        open={open}
        placement={placement as PopperProps['placement']}
        popperOptions={popperOptions}>
        {menuType === MenuType.GENERAL && (
          <BlockMenuList
            anchorEl={anchorEl}
            menuItems={menuItems(t, isLocalizedContent)}
            open={open}
            view={view}
          />
        )}
        {menuType === MenuType.TURN_INTO && (
          <TurnIntoMenuItems
            autoFocus={true}
            blocks={getTextOnlyNode(view)}
            selectedMenuItemIndex={getSelectedMenuItemIndex(currentlySelectedNode, view)}
            onClick={(block: blockType) => onTurnIntoClick(anchorEl, block, view)}
          />
        )}
      </Popper>
    </ClickAwayListener>
  );
};
